import angular from 'angular';
import classNames from 'classnames';
import { getRelationIconClass } from '@/shared/components/RelationTypeIcon';

angular.module('cloudX').component('cxRelationHandlingLevel', {
  template: `<i
      ng-if="$ctrl.visible"
      ng-class="$ctrl.iconClass"
      uib-tooltip="{{$ctrl.clarification}}"
      tooltip-placement="right"
      tooltip-class="linebreak text-left"
      tooltip-append-to-body="true"
    ></i>`,
  bindings: {
    handlingLevel: '<?',
    clarification: '<?',
    iclass: '@?',
  },
  controller: [
    function() {
      const ctrl = this;
      ctrl.$onChanges = function() {
        ctrl.visible = ctrl.handlingLevel > 1;
        ctrl.iconClass = classNames(
          'fa-fw fa-inline fa fa-exclamation-triangle',
          ctrl.handlingLevel === 2 ? 'text-warning' : 'text-danger',
          ctrl.iclass,
        );
      };
    },
  ],
});
